module.exports = __webpack_public_path__ + "static/1p-f26e167668cb94a2c55e2b26e242d4f8.webp";